import React, { useState, useEffect } from 'react';
import { HeaderComponent, FooterComponent, ExpectDialog, LoadingDialog } from '../../shared-component';
import AppTool from '@/apps/@utils/app-tool';


const UserPage = ({ item }) => {

  useEffect(() => {
    setTimeout(() => { AppTool.closeLoadingDialog('.cLoadingDialog') }, 2000);
  }, []);

  return (
    <div className="cUserPage">
      <ExpectDialog />
      <HeaderComponent />
      <LoadingDialog />
      <div className='cPcBox'>
        <img className="cImage" src={window.assetUrl(`/images/user/pc_user.png`)} />
      </div>
      <div className='cPhoneBox'>
        <img className="cImage" src={window.assetUrl(`/images/user/mobile_user_1.png`)} />
        <img className="cImage" src={window.assetUrl(`/images/user/mobile_user_2.png`)} />
      </div>
      <FooterComponent />
    </div>
  );
};

export default UserPage;

